import { business } from "./business";
import { admin } from "./admin";
import { rightholder } from "./rightholder";
import { employee } from "./employee";
export var paths = {
    login: function () { return "/login"; },
    register: function () { return "/register"; },
    password: {
        forgot: function () { return "/forgot-password"; },
        reset: function () { return "/reset-password"; },
    },
    business: business,
    admin: admin,
    rightholder: rightholder,
    employee: employee,
};
